import type { RouteLocationNormalized } from 'vue-router'

export default defineNuxtPlugin(() => {
  const store = useUtilsStore()
  const router = useRouter()

  router.afterEach((to: RouteLocationNormalized) => {
    document.title = to.name as string
    if (store.isOpen) {
      // store.sidebarToggle()
    }
  })
})
